import { Box } from "@mui/material";

export default function SupplementedFoodFacts () {
    return (
        <Box id="supplemented-food-facts">
            <img style={{marginBottom: '1em'}} src="https://s3.amazonaws.com/nutrition-calculator.tis.coke.com/static/media/supplemented.png" alt="Supplemented Foods Caution Identifier Required"/>
        </Box>
    )
}